var PROCUREMENT_SCRIPT_URL = 'https://script.google.com/macros/s/AKfycbxEbsaE4vEm5nGP5sq_wmepLgFVMdWdpGeqgUBIhrov_bahKN_NWu_MhxVE1NQDaf5k/exec';

// REVIEW NOTE:
// Using BuyCoop namespace for adapter-safe/global-safe access.
// (Previous code used only global functions.)
window.BuyCoop = window.BuyCoop || {};
window.BuyCoop.procurementSignal = window.BuyCoop.procurementSignal || {};

function ensureProcurementModalAtBodyLevel() {
  var modal = document.getElementById('procurementSignalModal');
  if (modal && modal.parentNode !== document.body) {
    document.body.appendChild(modal);
  }
}

function openProcurementSignalModal() {
  ensureProcurementModalAtBodyLevel();

  var modal = document.getElementById('procurementSignalModal');

  if (modal) {
    modal.style.display = 'flex';
    modal.style.opacity = '1';
    modal.style.visibility = 'visible';
    modal.style.pointerEvents = 'auto';
    modal.style.zIndex = '999999';
    document.body.style.overflow = 'hidden';
  } else {
    console.error('procurementSignalModal not found');
  }
}

function closeProcurementSignalModal() {
  var modal = document.getElementById('procurementSignalModal');
  if (modal) {
    modal.style.display = 'none';
    modal.style.opacity = '';
    modal.style.visibility = '';
    modal.style.pointerEvents = '';
    modal.style.zIndex = '';
    document.body.style.overflow = '';
  }
}

window.openProcurementSignalModal = openProcurementSignalModal;
window.closeProcurementSignalModal = closeProcurementSignalModal;
window.ensureProcurementModalAtBodyLevel = ensureProcurementModalAtBodyLevel;

// REVIEW NOTE:
// Keep old globals + expose namespaced aliases.
window.BuyCoop.procurementSignal.open = openProcurementSignalModal;
window.BuyCoop.procurementSignal.close = closeProcurementSignalModal;

document.addEventListener('keydown', function(event) {
  if (event.key === 'Escape') {
    closeProcurementSignalModal();
  }
});

// REVIEW NOTE:
// Legacy behavior was inline onclick in Liquid markup.
// We now bind via data attributes for CSP/new-theme resilience.
document.addEventListener('click', function(event) {
  var trigger = event.target.closest('[data-bc-procurement-trigger]');
  if (trigger) {
    event.preventDefault();
    openProcurementSignalModal();
    return;
  }

  var closeButton = event.target.closest('[data-bc-procurement-close]');
  if (closeButton) {
    event.preventDefault();
    closeProcurementSignalModal();
    return;
  }

  // Backdrop click close (moved from inline onclick).
  var modal = event.target.closest('[data-bc-procurement-modal]');
  if (modal && event.target === modal) {
    closeProcurementSignalModal();
  }
});

document.addEventListener('DOMContentLoaded', function() {
  var form = document.getElementById('procurementSignalForm');
  var formStart = document.getElementById('form_start');

  if (formStart) {
    formStart.value = Date.now();
  }

  if (!form) {
    console.warn('Procurement form not found at load');
    return;
  }

  form.addEventListener('submit', function(event) {
    event.preventDefault();

    var message = document.getElementById('procurementSignalMessage');
    var submitButton = form.querySelector('button[type="submit"]');

    if (!message || !submitButton) return;
    if (submitButton.disabled) return;

    submitButton.disabled = true;
    message.textContent = 'Submitting...';

    var payload = {
      name: document.getElementById('procurementName') ? document.getElementById('procurementName').value : '',
      mobile: document.getElementById('procurementMobile') ? document.getElementById('procurementMobile').value : '',
      organization: document.getElementById('procurementOrganization') ? document.getElementById('procurementOrganization').value : '',
      city: document.getElementById('procurementCity') ? document.getElementById('procurementCity').value : '',
      province: '',
      products_needed: document.getElementById('procurementProducts') ? document.getElementById('procurementProducts').value : '',
      estimated_quantity: document.getElementById('procurementAmount') ? document.getElementById('procurementAmount').value : '',
      notes: '',
      page_url: window.location.href,
      page_title: document.title,
      referrer: document.referrer,
      submitted_at: new Date().toISOString(),
      user_agent: navigator.userAgent,
      source_context: 'procurement_signal_popup',
      website: document.getElementById('website') ? document.getElementById('website').value : '',
      form_start: document.getElementById('form_start') ? document.getElementById('form_start').value : ''
    };

    fetch(PROCUREMENT_SCRIPT_URL, {
      method: 'POST',
      body: JSON.stringify(payload)
    })
      .then(function(response) {
        if (!response.ok) throw new Error('Network response was not ok');
        return response.text();
      })
      .then(function() {
        message.textContent = 'Submission received. We’ll review it for future supply case planning.';
        form.reset();
        if (formStart) {
          formStart.value = Date.now();
        }
      })
      .catch(function() {
        message.textContent = 'There was an error submitting your signal. Please try again.';
      })
      .finally(function() {
        submitButton.disabled = false;
      });
  });
});